export const spring = {
    type: "spring",
    damping: 45,
    stiffness: 500,
}